import { ModelBase } from 'store/model-base';

export class CmsNowModals extends ModelBase {
    public static storeName: string = 'cmsNowModals';

    public modals: NowModals;
}
